// extracted by mini-css-extract-plugin
export var blue = "_3w-h";
export var brand = "_3w-d";
export var darkGrey = "_3w-g";
export var disabled = "_3w-6";
export var disabledSubtle = "_3w-7";
export var error = "_3w-8";
export var green = "_3w-i";
export var grey = "_3w-f";
export var icon = "_3w-0";
export var inherit = "_3w-c";
export var lightGrey = "_3w-e";
export var orange = "_3w-k";
export var pink = "_3w-m";
export var primary = "_3w-1";
export var purple = "_3w-n";
export var quaternary = "_3w-4";
export var quinary = "_3w-5";
export var red = "_3w-l";
export var secondary = "_3w-2";
export var success = "_3w-b";
export var tertiary = "_3w-3";
export var warning = "_3w-9";
export var warningSecondary = "_3w-a";
export var white = "_3w-o";
export var yellow = "_3w-j";